webpackJsonp([17],{

/***/ 1126:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss__ = __webpack_require__(1126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__style_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_utils_localStore__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_api__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_redux__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_login_actions__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_promo_actions__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_user__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__home_rof_src_github_com_SauceyTeam_WebApp_src_client_config_production__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_modal__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__ = __webpack_require__(622);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var PROMO_CODE = (__WEBPACK_IMPORTED_MODULE_9__home_rof_src_github_com_SauceyTeam_WebApp_src_client_config_production__["a" /* default */].promoCodes.signup.tenOff || '').toUpperCase();
var VIEWED_AT_KEY = 'scyLeadCaptureModalViewedAt';

var LeadCaptureModal = function (_React$Component) {
  _inherits(LeadCaptureModal, _React$Component);

  function LeadCaptureModal(props) {
    _classCallCheck(this, LeadCaptureModal);

    var _this = _possibleConstructorReturn(this, (LeadCaptureModal.__proto__ || Object.getPrototypeOf(LeadCaptureModal)).call(this, props));

    _this.state = {
      showModal: false,
      over21: true,
      error: null,
      existingEmail: null,
      loading: false,
      success: false
    };

    _this.close = _this.close.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    _this.showLogin = _this.showLogin.bind(_this);
    return _this;
  }

  _createClass(LeadCaptureModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.timeoutId = this.showModal();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
        this.timeoutId = null;
      }
    }
  }, {
    key: 'showModal',
    value: function showModal() {
      var _this2 = this;

      if (this.isLoggedIn()) return;
      if (this.hasSeenRecently()) return;

      var delay = 10 * 1000; // 10 seconds

      return setTimeout(function () {
        if (_this2.isLoggedIn()) return;
        if (_this2.hasSeenRecently()) return;
        if (_this2.isLoggingIn() || _this2.isFillingInForm() || _this2.hasOpenModal() || _this2.isViewingCart()) {
          _this2.timeoutId = _this2.showModal();
          return;
        }
        _this2.setState({ showModal: true });
        _this2.persistViewedAt();
        Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Popup Offer - Email Form Viewed');
      }, delay);
    }
  }, {
    key: 'isLoggedIn',
    value: function isLoggedIn() {
      return this.props.login && !!this.props.login.user;
    }
  }, {
    key: 'isLoggingIn',
    value: function isLoggingIn() {
      return this.props.login && !!this.props.login.display;
    }
  }, {
    key: 'isFillingInForm',
    value: function isFillingInForm() {
      return !!document.querySelectorAll('input:focus').length;
    }
  }, {
    key: 'isViewingCart',
    value: function isViewingCart() {
      return this.props.isViewingCart;
    }
  }, {
    key: 'hasOpenModal',
    value: function hasOpenModal() {
      return !!document.getElementsByClassName('modal-overlay').length;
    }
  }, {
    key: 'hasSeenRecently',
    value: function hasSeenRecently() {
      var now = new Date();
      var lastSeen = __WEBPACK_IMPORTED_MODULE_2__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_utils_localStore__["a" /* default */].get(VIEWED_AT_KEY);
      var twentyFourHoursAgo = now - 24 * 60 * 60 * 1000;
      return lastSeen > twentyFourHoursAgo;
    }
  }, {
    key: 'persistViewedAt',
    value: function persistViewedAt() {
      var now = new Date().valueOf();
      __WEBPACK_IMPORTED_MODULE_2__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_utils_localStore__["a" /* default */].set(VIEWED_AT_KEY, now);
    }
  }, {
    key: 'close',
    value: function close() {
      var track = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.setState({ showModal: false });
      this.props.closeLeadCapture();
      if (track) Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Popup Offer - Closed');
    }
  }, {
    key: 'showLogin',
    value: function showLogin(event) {
      event.preventDefault();
      this.close();
      this.props.showLogin('login');
      Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Popup Offer - Show Login Clicked');
    }
  }, {
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      var _this3 = this;

      e.preventDefault();

      var _state = this.state,
          email = _state.email,
          over21 = _state.over21;


      this.setState({ error: null, existingEmail: null });

      if (!Object(__WEBPACK_IMPORTED_MODULE_8__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_user__["f" /* validEmail */])(email)) {
        this.setState({ error: 'Please enter a valid email address.' });
        return;
      }

      if (!over21) {
        this.setState({ error: 'You must be 21 or older to join Saucey.' });
        Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Popup Offer - Under 21 Selected');
        return;
      }

      this.setState({ loading: true });
      return Object(__WEBPACK_IMPORTED_MODULE_3__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_api__["l" /* checkEmailForAccount */])(email).then(function (res) {
        _this3.setState({ loading: false });
        if (res && res.user) {
          _this3.setState({ existingEmail: email });
          Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Popup Offer - Email Already Exists');
          return;
        } else {
          Object(__WEBPACK_IMPORTED_MODULE_5__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_login_actions__["identify"])({ email: email });
          Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Email Capture', {
            email: email,
            registrationSource: 'Email Capture'
          });
          Object(__WEBPACK_IMPORTED_MODULE_3__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_api__["o" /* emailCaptureEvent */])(email);
          _this3.setState({ success: true });
          Object(__WEBPACK_IMPORTED_MODULE_7__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_models_analytic__["b" /* trackNow */])('Popup Offer - Success Message Viewed');
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_modal__["a" /* default */],
        {
          isOpen: this.state.showModal,
          handleClose: function handleClose() {
            return _this4.close(true);
          },
          className: 'lead-capture__modal'
        },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
          'div',
          { className: 'lead-capture__container row center-xs middle-xs start-md' },
          __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
            'div',
            { className: 'col-xs-12 col-sm-7 col-md-12' },
            this.state.success ? __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
              { padding: { sides: 'sm' }, margin: 'xl' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                {
                  title: true,
                  size: 'xl',
                  weight: 'med',
                  tag: 'h1',
                  lg: { size: 'xxl' },
                  margin: 'none'
                },
                'Welcome to the Good Life'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
                { tag: 'p', margin: 'md' },
                'Use code',
                ' ',
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                  { tag: 'span', weight: 'bold' },
                  PROMO_CODE,
                  ' for $10 off your order'
                ),
                '. We\u2019ll email you our best deals, discounts and special event invitations!'
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'div',
                { className: 'row' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'col-xs-12 col-md-6' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'button',
                    {
                      type: 'button',
                      className: 'btn-primary btn--full-width btn-block',
                      onClick: function onClick() {
                        return _this4.close();
                      }
                    },
                    'Start Shopping'
                  )
                )
              )
            ) : __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
              __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
              { padding: { sides: 'sm' }, margin: 'md' },
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
                { margin: 'sm' },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                  {
                    title: true,
                    size: 'xl',
                    weight: 'med',
                    tag: 'h1',
                    lg: { size: 'xxl' },
                    margin: 'none'
                  },
                  'Get $10 Off!'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                  { tag: 'p', size: 'md' },
                  'Sign up to redeem a $10 discount on your first order.'
                )
              ),
              __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                'form',
                { onSubmit: this.handleSubmit },
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { className: 'row' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12 col-md-8' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
                      { margin: 'xs' },
                      __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                        type: 'email',
                        name: 'email',
                        placeholder: 'Enter email address',
                        className: 'lead-capture__input',
                        value: this.state.email,
                        onChange: function onChange(e) {
                          return _this4.setState({ email: e.target.value });
                        }
                      })
                    )
                  ),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    'div',
                    { className: 'col-xs-12 col-md-4' },
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'button',
                      {
                        type: 'submit',
                        className: 'btn-primary btn--full-width btn-block',
                        disabled: this.state.loading
                      },
                      'Sign Up'
                    )
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
                  { tag: 'p', margin: 'xs' },
                  'We promise',
                  ' ',
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                    { tag: 'span', weight: 'bold' },
                    'never to spam'
                  ),
                  ' ',
                  'or give your email away.'
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'label',
                  { htmlFor: 'verify21', className: 'clickable' },
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('input', {
                    type: 'checkbox',
                    id: 'verify21',
                    name: 'verify21',
                    checked: this.state.over21,
                    onChange: function onChange(e) {
                      _this4.setState({ over21: e.target.checked });
                    }
                  }),
                  __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_11__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_view__["a" /* default */],
                    { inlineBlock: true, padding: { sides: 'xs' }, margin: 'sm' },
                    'I am at least 21 years of age.'
                  )
                ),
                __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                  'div',
                  { style: { height: '2em' } },
                  this.state.error && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                    { error: true },
                    this.state.error
                  ),
                  this.state.existingEmail && __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                    __WEBPACK_IMPORTED_MODULE_12__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_ui_text__["b" /* default */],
                    { error: true },
                    'We already have an account for',
                    ' ',
                    this.state.existingEmail,
                    '.',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('br', null),
                    'If that',
                    "'",
                    's you,',
                    ' ',
                    __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
                      'a',
                      {
                        href: '/?login=1',
                        className: 'link-text',
                        onClick: this.showLogin
                      },
                      'login'
                    ),
                    '.'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LeadCaptureModal;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

function mapStateToProps(state) {
  return {
    login: state.login,
    isViewingCart: !!state.cart.show
  };
}

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_redux__["b" /* connect */])(mapStateToProps, {
  showLogin: __WEBPACK_IMPORTED_MODULE_5__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_login_actions__["showLogin"],
  addPromo: __WEBPACK_IMPORTED_MODULE_6__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_promo_actions__["a" /* apply */],
  closeLeadCapture: __WEBPACK_IMPORTED_MODULE_5__home_rof_src_github_com_SauceyTeam_WebApp_src_shared_components_login_actions__["closeLeadCapture"]
})(LeadCaptureModal));

/***/ })

});


// WEBPACK FOOTER //
// leadCaptureModal.665d0eee48f26f7b2345.js